<template>
  <div
    class="NewPass"
    @click="$emit('close')"
  >
    <div
      class="login-box"
      @click.stop
    >
      <img src="@/assets/images/logo.svg">
      <form
        @keyup.enter="send"
      >
        <BaseInput
          v-for="(field, i) in fields"
          :key="i"
          v-model="field.value"
          v-bind="field"
        >
          <template #error>
            <ValidationError
              :errors="errors"
              :name="field.name"
            />
          </template>
        </BaseInput>
      </form>
      <BaseButton
        @click="send"
      >
        {{ $t('BUTTON.SEND') }}
      </BaseButton>
    </div>
  </div>
</template>

<script>
// import { get } from 'vuex-pathify';
import ValidationMixin from '@/mixins/ValidationMixin.js';
import ValidationError from '@/components/ValidationError.vue';

export default {


  components: {
    ValidationError,
  },

  mixins: [ValidationMixin],

  data: () => ({
    fields: [
      {
        type: 'password', name: 'password', value: undefined, placeholder: this.$t('AUTHORFORM.PASSWORDPLACEHOLDER'), required: 'required',
      },
      {
        type: 'password', name: 'repeatpass', value: undefined, placeholder: this.$t('AUTHORFORM.PASSWORDREPEATPLACEHOLDER'), required: 'required',
      },
    ],
    error: false,
  }),

  // computed: {
  //   ...get('authModule')},
  async created() {
    const { passCode } = this.$route.params;
    await this.$store.dispatch('authModule/checkPassword', passCode);
    // this.author = this.getAuthor();
  },

  methods: {

    getField(name) {
      return this.fields.find(field => field.name === name)?.value;
    },

    send() {
      // const { passCode } = this.$route.params;
      const password = this.getField('password');
      const repeatpass = this.getField('repeatpass');
      try {
        if (this.areErrors()) {
          throw new Error(this.$t('FORM.MESSAGE.ERROR.CHECKFIELDS'));
        } else {
          const currentForm = document.forms[0];
          if (password !== repeatpass) {
            const repeatpassField = currentForm.querySelector('[name=repeatpass]');
            this.forceErrorElement(repeatpassField, 'Las contraseñas deben coincidir'); // mensaje debajo del campo
            throw new Error('Las contraseñas deben coincidir'); // mensaje en toast
          }
          const formData = new FormData(currentForm);

          this.$store.dispatch('authModule/newPassword', formData);
          this.$emit('close');
        }
      } catch (error) {
        this.$toast.error(error.message);
      }
    },
  },

};
</script>

<style lang="scss" scoped>
.NewPass {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(255, 255, 255, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  .login-box {
    padding: 2rem 4rem;
    background-color: rgb(33, 33, 49);
    border-radius: 1rem;
    width: 450px;
    text-align: center;
    img{
      width: 250px;
      margin-bottom: 1rem;
    }
    .BaseInput {
      ::v-deep {
        input {
          border-radius: 10px;
          border: solid 2px var(--color-primary);
          // border-bottom: solid 1px white;
          color: rgb(37, 35, 35);
          text-align: center;
          border-radius: 10px;
          width: 100%;
          padding-top: 6px;
          margin-bottom: 1rem;
        }
      }
    }
    .recover{
      color:white;
      text-align: left;
      margin-top: -15px;

    }
    .BaseButton {
      margin-top: 15px;
      text-align: center;

    }
  }
}
</style>
